var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFailure(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 183,
    height: 120,
    viewBox: "0 0 183 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 82,
    width: 183,
    height: 38,
    rx: 8,
    fill: "#92292D",
    fillOpacity: 0.3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M91.9999 9.33203C66.2399 9.33203 45.3333 30.2387 45.3333 55.9987C45.3333 81.7587 66.2399 102.665 91.9999 102.665C117.76 102.665 138.667 81.7587 138.667 55.9987C138.667 30.2387 117.76 9.33203 91.9999 9.33203ZM54.6666 55.9987C54.6666 35.372 71.3733 18.6654 91.9999 18.6654C100.633 18.6654 108.567 21.6054 114.867 26.552L62.5533 78.8654C57.4282 72.3467 54.6497 64.2908 54.6666 55.9987ZM91.9999 93.332C83.3666 93.332 75.4333 90.392 69.1333 85.4454L121.447 33.132C126.572 39.6507 129.35 47.7065 129.333 55.9987C129.333 76.6254 112.627 93.332 91.9999 93.332Z",
    fill: "#92292D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFailure);
export default __webpack_public_path__ + "static/media/failure.554ba58c76a908682630a6c51f05f1a9.svg";
export { ForwardRef as ReactComponent };